var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalWithButton',{attrs:{"name":"crear-direccion","title":"Crear nueva dirección fiscal","button_title":"Crear nueva dirección fiscal"},on:{"cerrar":function($event){this.direccionFiscal = {}}}},[_c('FormDireccionFiscal',{attrs:{"direccionFiscal":_vm.direccionFiscal},on:{"terminado":function($event){return _vm.crearDireccionFiscal()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }